var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#002575",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 3.067c2.933-.042 5.858 2.009 7.621 3.949.501.559.502 1.405.002 1.965-1.744 1.92-4.627 3.952-7.525 3.952h-.205c-2.888 0-5.772-2.032-7.514-3.952-.5-.56-.5-1.405 0-1.965C2.142 5.076 5.067 3.025 8 3.066zm0 1.866C6.306 4.933 4.933 6.306 4.933 8c0 1.694 1.373 3.067 3.067 3.067 1.694 0 3.067-1.373 3.067-3.067 0-1.694-1.373-3.067-3.067-3.067zm0 1.734c.736 0 1.333.597 1.333 1.333S8.736 9.333 8 9.333 6.667 8.736 6.667 8 7.264 6.667 8 6.667z",
    transform: "translate(-120 -303) translate(31 287) translate(81 8) translate(8 8)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye-on.07a128394ad1d0e1aee2a0a1e2981167.svg";
export { ForwardRef as ReactComponent };